<template>
  <div class="psso-wrap">
    <div class="psso-card">

      <!-- Icon circle -->
      <div class="psso-icon" :class="{ success: step === 'done', error: step === 'error' }">
        <svg v-if="step === 'done'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
        </svg>
        <svg v-else-if="step === 'error'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
        <div v-else class="psso-spinner"></div>
      </div>

      <!-- Text -->
      <div class="psso-title">{{ title }}</div>
      <div class="psso-sub">{{ subtitle }}</div>

      <!-- Dots while loading -->
      <div v-if="step === 'loading'" class="psso-dots">
        <span></span><span></span><span></span>
      </div>

      <!-- Error: offer manual login -->
      <a v-if="step === 'error'" href="/login" class="psso-back">← Back to Login</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartnerSso',

  data() {
    return {
      step:     'loading',
      title:    'Signing you in…',
      subtitle: 'Setting up your partner session, please wait.',
    };
  },

  created() {
    this.setup();
  },

  methods: {
    setup() {
      try {
        const q = this.$route.query;

        // Decode base64 params sent by starrboard-website after login
        const b64d = (s) => {
          try { return s ? decodeURIComponent(escape(atob(s))) : ''; }
          catch { return ''; }
        };

        const token   = b64d(q.pt);
        const pid     = b64d(q.pid);
        const pname   = b64d(q.pn);
        const pcomp   = b64d(q.pc);
        const pemail  = b64d(q.pe);

        if (!token) throw new Error('Missing partner session token.');

        // Immediately wipe params from address bar so token doesn't linger
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, document.title, '/partner_sso');
        }

        // Store partner session in localStorage
        localStorage.setItem('PARTNER_TOKEN',   token);
        localStorage.setItem('PARTNER_ID',      pid);
        localStorage.setItem('PARTNER_NAME',    pname);
        localStorage.setItem('PARTNER_COMPANY', pcomp);
        localStorage.setItem('PARTNER_EMAIL',   pemail);

        this.step     = 'done';
        this.title    = 'Welcome back!';
        this.subtitle = `Redirecting to your dashboard…`;

        setTimeout(() => this.$router.replace('/partner_landing_v2'), 600);

      } catch (err) {
        console.error('[PartnerSso]', err);
        this.step     = 'error';
        this.title    = 'Sign-in failed';
        this.subtitle = err.message || 'Could not start your session. Please log in manually.';
      }
    },
  },
};
</script>

<style scoped>
.psso-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%);
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
}

.psso-card {
  background: #fff;
  border-radius: 20px;
  padding: 48px 40px 40px;
  text-align: center;
  box-shadow: 0 8px 40px rgba(59, 76, 192, 0.10);
  max-width: 400px;
  width: 90%;
}

.psso-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #EEF0FD;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  transition: background 0.3s;
}
.psso-icon svg { width: 32px; height: 32px; color: #3B4CC0; }
.psso-icon.success { background: #DCFCE7; }
.psso-icon.success svg { color: #16a34a; }
.psso-icon.error { background: #FEE2E2; }
.psso-icon.error svg { color: #dc2626; }

.psso-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #C7CCEF;
  border-top-color: #3B4CC0;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

.psso-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1E1E2F;
  margin-bottom: 8px;
}
.psso-sub {
  font-size: 0.875rem;
  color: #9A96A8;
  margin-bottom: 20px;
}

.psso-dots {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 8px;
}
.psso-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #C7CCEF;
  animation: bounce 1.2s ease-in-out infinite;
}
.psso-dots span:nth-child(1) { animation-delay: 0s; }
.psso-dots span:nth-child(2) { animation-delay: 0.2s; }
.psso-dots span:nth-child(3) { animation-delay: 0.4s; }
@keyframes bounce {
  0%, 80%, 100% { transform: scale(0.7); opacity: 0.4; }
  40%           { transform: scale(1.1); opacity: 1; }
}

.psso-back {
  display: inline-block;
  margin-top: 8px;
  font-size: 0.85rem;
  color: #3B4CC0;
  text-decoration: none;
  font-weight: 600;
}
.psso-back:hover { text-decoration: underline; }
</style>
